import { Bus } from "baconjs"

import { L10n } from "@encoway/l10n"

import { Events } from "../../constants"
import { Constants } from "./constants"
import { download } from "./helper"
import {
    IVisualizationExtensionCADHelper,
    IVisualizationOption,
    IVisualizationServer
} from "./visualizationService.types"

export function generateSTEP(
    vis: IVisualizationServer,
    option: IVisualizationOption,
    eventBus: Bus<any>
) {
    vis.cloud.addPendingEvent(Constants.PendingEvent.CreateSTEP)

    generateAndDownloadSTEP(vis, option)
        .catch((err) => {
            console.error("Error while creating DXF file", err)
            eventBus.push({
                type: Events.ShowError,
                message: L10n.format("Application.Visualization.STEP.error")
            })
        })
        .finally(() =>
            vis.cloud.removePendingEvent(Constants.PendingEvent.CreateSTEP)
        )
}

async function generateAndDownloadSTEP(
    vis: IVisualizationServer,
    option: IVisualizationOption
) {
    const cloud = vis.cloud
    const cadHelper = (await vis.useExtension(
        Constants.Extension.CADHelper,
        vis.version,
        cloud.token
    )) as IVisualizationExtensionCADHelper

    const cadBlueprint = await cadHelper.prepareCad(cloud)

    const request = new Request(`${option.baseUrl}/convert`, {
        method: "POST",
        headers: new Headers({
            Accept: option.zip ? "model/step+zip" : "model/step",
            "Content-Type": "application/vnd.encoway.step+zip",
            Authorization: "Bearer " + cloud.token
        }),
        body: cadBlueprint
    })

    const response = await fetch(request)
    if (!response.ok) {
        throw response
    }

    const blob = await response.blob()
    const filename = option.zip ? "model.stpZ" : "model.stp"
    download(blob, filename)
}
